@let completeItemCount = completeItemCount$ | async;
@if (completeItemCount) {
  <div class="cart-widget">
    <a
      class="cart-toggle position-relative d-flex align-items-center"
      [routerLink]="['/shop-cart']"
      title="Warenkorb"
      i18n-title
    >
      <fa-icon [icon]="faShoppingCart" class="fs-5"></fa-icon>
      <span class="badge rounded-pill bg-primary cart-count">{{ completeItemCount }}</span>
    </a>

    <div class="cart-panel">
      <div class="card shadow-sm">
        <div class="card-body p-3">
          <div class="d-flex align-items-center mb-3">
            <fa-icon [icon]="faShoppingCart" class="fs-5 text-secondary"></fa-icon>
            <span class="ms-2 fw-medium"
              >{{ completeItemCount }}&nbsp;<ng-container i18n>Artikel</ng-container></span
            >
          </div>
          <button class="btn btn-sm btn-primary w-100" type="button" [routerLink]="['/shop-cart']" i18n>
            Zum Warenkorb
          </button>
        </div>
      </div>
    </div>
  </div>
}
